import { Point } from "./linearAlgebraModel";

export function makePolygonString(points: Array<Point>): string {
  let string = "";
  points.forEach((point) => {
    string = string + " " + point[0] + "," + point[1];
  });
  return string;
}
